export default __webpack_public_path__ + "static/media/InstantPayment.ee4c9d79.png";